import { useContext } from 'react';
import { Box, Paper, Typography, Button, Stack, ButtonGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormMode, USysObjects } from '../utils/extensions/constantEx';
import { HomeContext } from '../utils/contexts/homeContext';

export default function NurseFormHeader(props) {
    const { formMode, handleEditClick, handleSaveClick, handleCancelClick, handleOpenNewSalaryPaymentClick, handleOpenAdvancePaymentClick } = props;
    const { homeState } = useContext(HomeContext);

    return (

        <Paper sx={{ zIndex: '900' }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={2}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        {
                            formMode === FormMode.EditMode ? 'Edit Nurse' :
                                formMode === FormMode.NewMode ? 'New Nurse' : 'View Nurse'
                        }
                    </Typography>
                </Grid>
                <Grid size={10}>
                    <Box sx={{ pr: 1, float: 'right', paddingTop: '14px' }}>
                        <Stack direction="row" spacing={2}>
                            {
                                formMode === FormMode.ViewMode &&
                                (homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.NurseAdvancePayments && col.is_add_new) ||
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.NurseSalaryPayments && col.is_add_new)) &&
                                <ButtonGroup variant="contained" aria-label="nurse pay button group">
                                    {
                                        homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.NurseAdvancePayments && col.is_add_new) &&
                                        <Button variant="contained" onClick={handleOpenAdvancePaymentClick}>New Advance Payment</Button>
                                    }
                                    {
                                        homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.NurseSalaryPayments && col.is_add_new) &&
                                        <Button variant="contained" onClick={handleOpenNewSalaryPaymentClick}>New Salary Payment</Button>
                                    }
                                </ButtonGroup>
                            }
                            {
                                formMode === FormMode.ViewMode &&
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_edit) &&
                                <Button variant="contained" onClick={handleEditClick}>Edit</Button>
                            }
                            {
                                formMode !== FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleSaveClick}>Save</Button>
                            }
                            <Button variant="outlined" onClick={handleCancelClick}>
                                {formMode === FormMode.ViewMode ? 'Close' : 'Cancel'}
                            </Button>
                        </Stack>

                    </Box>
                </Grid>
            </Grid>
        </Paper>

    );
}
